/**
 * Created by Administrator on 2018/11/28 0028.
 */
/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage0
 */
export const getStore = name => {
  if (!name) return;
  //return 'Bearer 5974aeea-c764-439d-8269-3b0a479b7672'
  return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
}




// WEBPACK FOOTER //
// ./src/storage.js